/* eslint react/prop-types:0 */
import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { LoadablePaint } from '@confluence/loadable';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

const SitePermissions = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluencesite-permissionsentry-pointsSitePermissions" */ '@confluence/site-permissions/entry-points/SitePermissions'
			)
		).SitePermissions,
});

export const GlobalPermissionRoute = () => (
	<Screen screenEvent={{ name: 'sitePermissionsScreen' }}>
		<MainLayout navView={ADMIN_HOME_ID}>
			<SitePermissions />
		</MainLayout>
	</Screen>
);
